import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { GuideSection } from './components/GuideSection';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  useEffect(() => {
    document.title = 'IndicadoresVIP | Aprende Trading y Educación Financiera';
  }, []);
  return <div className="min-h-screen bg-dark text-white selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <GuideSection data-id="element-5" />
        <WhyUs data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <FloatingWhatsApp data-id="element-10" />
    </div>;
}